function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_back)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 159.831L383.2 254.471L159.28 383.751L30 159.831Z",
  fill: "url(#paint0_linear_back)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_back)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M944.949 510.472L1037.15 166.373L1159.01 283.947L944.949 510.472Z",
  fill: "url(#paint1_linear_back)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_back)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M408.77 526.871L304.556 607.332L309.985 667.745L408.77 526.871Z",
  fill: "url(#paint2_linear_back)"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_back",
  x: 0,
  y: 0.550903,
  width: 413.2,
  height: 413.2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_back",
  x: 789,
  y: 113,
  width: 444.583,
  height: 427.472,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_back",
  x: 267,
  y: 484.994,
  width: 171.769,
  height: 222.957,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_back",
  x1: 288.15,
  y1: 302.321,
  x2: 74.0817,
  y2: 353.388,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEFFDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFFC7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_back",
  x1: 1083.77,
  y1: 258.974,
  x2: 1133.52,
  y2: 467.526,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEFFDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFFC7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_back",
  x1: 335.398,
  y1: 667.399,
  x2: 416.632,
  y2: 663.162,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DEFFDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFFC7"
})));

var SvgBackTriangles = function SvgBackTriangles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1234,
    height: 708,
    viewBox: "0 0 1234 708",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackTriangles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-triangles.7afee916.svg";
export { ForwardRef as ReactComponent };